/*
 * InnerBloom – coș rapid (panoul „Produs adăugat în coș” + pagina de coș).
 * Config: snippets/ib-cart-sheet.liquid (#ib-cart-config). Stiluri: assets/ib-cart.css.
 *
 * 1. Interceptează formularele „Adaugă în coș” (pagina de produs, quick shop) și adaugă prin /cart/add.js,
 *    fără redirecționare spre coș. Dacă ceva nu merge, revine la trimiterea normală a formularului.
 * 2. Prinde și adăugările rapide ale temei (evenimentul ajaxProduct:added din colecții).
 * 3. Deschide panoul: produsul adăugat, bara de livrare gratuită, recomandări cu adăugare rapidă,
 *    subtotal, „Vezi coșul” și „Continuă cumpărăturile”.
 * 4. Pe pagina de coș: link înapoi la ultima pagină, recomandări, puncte Bloom Club,
 *    buton „Finalizează comanda” fix jos pe mobil.
 */
(function () {
  'use strict';
  if (window.__ibCartLoaded) return;
  window.__ibCartLoaded = true;

  var cfgEl = document.getElementById('ib-cart-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var isCartPage = document.body.classList.contains('template-cart');
  var EV_ADDED = 'ajaxProduct:added';
  var EV_UPDATED = 'cart:updated';

  /* ---------------- utilitare ---------------- */
  function store(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function tpl(s, map) {
    return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function rate() {
    var r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function group(n, prec, thou, dec) {
    var parts = (Math.round(n * Math.pow(10, prec)) / Math.pow(10, prec)).toFixed(prec).split('.');
    var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts[1] ? int + dec + parts[1] : int;
  }
  function formatWith(cents, format) {
    var v = cents / 100;
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = group(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = group(v, 2, "'", '.'); break;
      case 'amount_with_space_separator': out = group(v, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': out = group(v, 2, ' ', '.'); break;
      default: out = group(v, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }
  function money(cents, currency) {
    currency = currency || C.currency;
    if (currency === C.shopCurrency && C.moneyFormat) return formatWith(cents, C.moneyFormat);
    try {
      return new Intl.NumberFormat(C.locale || 'ro', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }
  // Același stil ca tema: zecimalele ridicate („129⁰⁰ lei”).
  function priceHTML(cents, currency) {
    currency = currency || C.currency;
    var s = esc(money(cents, currency));
    if (C.superscript && currency === C.shopCurrency) {
      var i = s.indexOf(C.superscript);
      if (i > -1) s = s.slice(0, i) + '<sup>' + s.slice(i + 1) + '</sup>';
    }
    return s;
  }
  function itemsLabel(n) {
    return n === 1 ? T.items1 : tpl(T.itemsN, { n: n });
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (/[?&]width=/.test(src)) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function setCount(n) {
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', n > 0);
      var num = b.querySelector('.cart-link__bubble-num');
      if (num) num.textContent = n;
    });
  }
  function shippingInfo(cart) {
    if (!C.threshold) return null;
    var thr = Math.round(C.threshold * (cart.currency === C.shopCurrency ? 1 : rate()));
    var total = cart.total_price;
    var left = Math.max(thr - total, 0);
    return {
      left: left,
      pct: thr > 0 ? Math.min(100, (total * 100) / thr) : 100,
      html: left > 0
        ? tpl(esc(T.shipLeft), { amount: '<strong>' + esc(money(left, cart.currency)) + '</strong>' })
        : esc(T.shipDone)
    };
  }
  function truckSVG() {
    return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
      '<path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3.2v2.8h-7z" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>' +
      '<circle cx="6.5" cy="17" r="1.6" fill="#FAF8F5" stroke="currentColor" stroke-width="1.4"/>' +
      '<circle cx="17" cy="17" r="1.6" fill="#FAF8F5" stroke="currentColor" stroke-width="1.4"/></svg>';
  }
  function variantText(item) {
    var out = [];
    if (!item.product_has_only_default_variant && item.options_with_values) {
      item.options_with_values.forEach(function (o) {
        if (o.value && o.value !== 'Default Title') out.push(String(o.name || '').replace(/:+\s*$/, '') + ': ' + o.value);
      });
    }
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (k.charAt(0) !== '_' && v) out.push(k.replace(/:+\s*$/, '') + ': ' + v);
      });
    }
    return out.join(' · ');
  }

  /* ---------------- „Continuă cumpărăturile”: ținem minte ultima pagină ---------------- */
  if (!isCartPage && !/\/(checkouts?|account|challenge|password)(\/|$)/.test(location.pathname)) {
    store('ib:last', location.pathname + location.search);
  }

  /* ---------------- recomandări ---------------- */
  function fetchSection(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw r; return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrap = doc.querySelector('[data-ib-recs]');
        var cnt = doc.querySelector('[data-ib-count]');
        return { el: wrap, count: cnt ? parseInt(cnt.getAttribute('data-ib-count'), 10) || 0 : 0 };
      });
  }
  // Amestecă două liste de carduri: accesorii din colecția de coș (cross-sell) alternativ cu
  // produse înrudite (up-sell / alte nuanțe), fără dubluri, maxim 8.
  function blend(a, b) {
    var lists = [a, b].filter(function (r) { return r && r.el && r.count; });
    if (!lists.length) return { el: null, count: 0 };
    if (lists.length === 1) return lists[0];
    var wrap = lists[0].el.cloneNode(false);
    var cardsA = lists[0].el.querySelectorAll('[data-ib-card]');
    var cardsB = lists[1].el.querySelectorAll('[data-ib-card]');
    var seen = {}, n = 0;
    for (var i = 0; n < 8 && (i < cardsA.length || i < cardsB.length); i++) {
      [cardsA[i], cardsB[i]].forEach(function (c) {
        if (!c || n >= 8) return;
        var id = c.getAttribute('data-product-id');
        if (seen[id]) return;
        seen[id] = 1;
        wrap.appendChild(c.cloneNode(true));
        n++;
      });
    }
    wrap.setAttribute('data-source', 'blend');
    return { el: wrap, count: n };
  }
  function fetchRecs(productId) {
    var fallbackUrl = ROOT + '?section_id=ib-cart-recs';
    if (!productId) return fetchSection(fallbackUrl);
    var base = ROOT + 'recommendations/products?section_id=ib-cart-recs&limit=10&product_id=' + encodeURIComponent(productId);
    var none = function () { return { el: null, count: 0 }; };
    // 1. Produse complementare (setate în Search & Discovery) – cele mai relevante.
    return fetchSection(base + '&intent=complementary')
      .then(function (res) {
        if (res.el && res.el.getAttribute('data-source') === 'recs' && res.count >= 2) return res;
        // 2. Altfel: accesorii din colecția de coș + produse înrudite, alternativ.
        return Promise.all([
          fetchSection(fallbackUrl).catch(none),
          fetchSection(base + '&intent=related').then(function (r) {
            return r.el && r.el.getAttribute('data-source') === 'recs' ? r : none();
          }).catch(none)
        ]).then(function (both) { return blend(both[0], both[1]); });
      })
      .catch(function () { return fetchSection(fallbackUrl); });
  }
  function skeleton(n) {
    var s = '<div class="ibr ibr--loading" aria-hidden="true">';
    for (var i = 0; i < n; i++) s += '<div class="ibr__card"><div class="ibr__img"></div><div class="ibr__sk"></div><div class="ibr__sk ibr__sk--short"></div></div>';
    return s + '</div>';
  }
  function loadRecs(productId, rail, block) {
    if (!rail) return;
    rail.innerHTML = skeleton(3);
    if (block) block.hidden = false;
    fetchRecs(productId).then(function (res) {
      if (!res.el || !res.count) {
        rail.innerHTML = '';
        if (block) block.hidden = true;
        return;
      }
      rail.innerHTML = '';
      rail.appendChild(document.importNode(res.el, true));
    }).catch(function () {
      rail.innerHTML = '';
      if (block) block.hidden = true;
    });
  }

  // Alegerea variantei într-un card de recomandare.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-ib-variant]')) return;
    var card = sel.closest('[data-ib-card]');
    if (!card) return;
    var btn = card.querySelector('[data-ib-add]');
    if (btn) btn.setAttribute('data-variant-id', sel.value);
    var opt = sel.options[sel.selectedIndex];
    var price = card.querySelector('[data-ib-price]');
    if (opt && price && opt.getAttribute('data-price')) {
      var s = esc(opt.getAttribute('data-price'));
      if (C.superscript && C.currency === C.shopCurrency) {
        var i = s.indexOf(C.superscript);
        if (i > -1) s = s.slice(0, i) + '<sup>' + s.slice(i + 1) + '</sup>';
      }
      price.innerHTML = s;
    }
  });

  // „+ Adaugă” dintr-un card de recomandare.
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-ib-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    var card = btn.closest('[data-ib-card]');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: 'cart-ajax' })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw res.j;
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML = '<span aria-hidden="true">✓</span> ' + esc(T.added_btn);
        if (card) card.classList.add('is-added');
        return getCart().then(function (cart) {
          afterChange(cart, res.j);
          if (isCartPage && card) {
            setTimeout(function () { card.classList.add('is-leaving'); }, 900);
            setTimeout(function () { card.remove(); }, 1250);
          }
        });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        flashError(card || btn.parentNode, (err && (err.description || err.message)) || T.error);
      });
  });

  function flashError(container, msg) {
    if (!container) return;
    var old = container.querySelector('.ib-err');
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'ib-err';
    p.setAttribute('role', 'alert');
    p.textContent = typeof msg === 'string' ? msg : T.error;
    container.appendChild(p);
    setTimeout(function () { if (p.parentNode) p.remove(); }, 5000);
  }

  // După orice modificare făcută de noi: numărul din header, panoul, pagina de coș.
  function afterChange(cart, response) {
    setCount(cart.item_count);
    if (sheet && sheet.classList.contains('is-open')) renderTotals(cart);
    // Anunțăm tema (pagina de coș își reconstruiește lista de produse).
    document.dispatchEvent(new CustomEvent(EV_ADDED, {
      bubbles: true,
      detail: { product: response, ibHandled: true, preventCartOpen: true }
    }));
    if (isCartPage) refreshSummary(cart);
  }

  /* ---------------- panoul „Produs adăugat în coș” ---------------- */
  var sheet, panel, lastFocus;

  function buildSheet() {
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'ibcs';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="ibcs__backdrop" data-ibcs-close></div>' +
      '<section class="ibcs__panel" role="dialog" aria-modal="true" aria-labelledby="ibcs-title" tabindex="-1">' +
        '<div class="ibcs__grip" aria-hidden="true"></div>' +
        '<header class="ibcs__head">' +
          '<span class="ibcs__check" aria-hidden="true"><svg viewBox="0 0 20 20" width="12" height="12"><path d="M4 10.5l3.6 3.5L16 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
          '<h2 class="ibcs__title" id="ibcs-title"></h2>' +
          '<button type="button" class="ibcs__x" data-ibcs-close aria-label="' + esc(T.close) + '">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="ibcs__body">' +
          '<div class="ibcs__added" data-ibcs-added></div>' +
          '<div class="ibcs__ship" data-ibcs-ship hidden></div>' +
          '<div class="ibcs__recs" data-ibcs-recs hidden>' +
            '<h3 class="ibcs__recs-title">' + esc(T.recsTitle) + '</h3>' +
            '<div class="ibcs__rail" data-ibcs-rail></div>' +
          '</div>' +
        '</div>' +
        '<footer class="ibcs__foot">' +
          '<div class="ibcs__sub"><span data-ibcs-count></span><strong data-ibcs-total></strong></div>' +
          '<a class="btn ibcs__go" href="' + esc(C.cartUrl || '/cart') + '">' + esc(T.viewCart) + '</a>' +
          '<button type="button" class="btn btn--secondary ibcs__cont" data-ibcs-close>' + esc(T.cont) + '</button>' +
        '</footer>' +
      '</section>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.ibcs__panel');

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ibcs-close]')) { e.preventDefault(); closeSheet(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!sheet.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeSheet();
      if (e.key === 'Tab') trapTab(e);
    });
    initSwipe();
  }

  function trapTab(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Trage în jos ca să închizi (mobil).
  function initSwipe() {
    var startY = null, dy = 0, body = panel.querySelector('.ibcs__body');
    panel.addEventListener('touchstart', function (e) {
      var inHead = e.target.closest('.ibcs__grip, .ibcs__head');
      if (!inHead && body.scrollTop > 0) { startY = null; return; }
      if (!inHead && !e.target.closest('.ibcs__body')) { startY = null; return; }
      if (e.target.closest('.ibcs__rail')) { startY = null; return; }
      startY = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (startY === null) return;
      dy = e.touches[0].clientY - startY;
      if (dy > 0) panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (startY === null) return;
      panel.style.transform = '';
      if (dy > 90) closeSheet();
      startY = null;
    });
  }

  function renderAdded(items) {
    var box = sheet.querySelector('[data-ibcs-added]');
    var it = items[0];
    var extra = items.length - 1;
    var img = it.featured_image && it.featured_image.url ? it.featured_image.url : it.image;
    var vt = variantText(it);
    box.innerHTML =
      '<a class="ibcs__img" href="' + esc(it.url) + '">' +
        (img ? '<img src="' + esc(imgUrl(img, 200)) + '" alt="" width="100" height="100">' : '') +
      '</a>' +
      '<div class="ibcs__info">' +
        '<a class="ibcs__name" href="' + esc(it.url) + '">' + esc(it.product_title || it.title) + '</a>' +
        (vt ? '<p class="ibcs__variant">' + esc(vt) + '</p>' : '') +
        '<p class="ibcs__price">' +
          (it.original_price > it.final_price ? '<s>' + priceHTML(it.original_price) + '</s> ' : '') +
          '<span>' + priceHTML(it.final_price) + '</span>' +
          (it.quantity > 1 ? ' <span class="ibcs__qty">· ' + esc(tpl(T.inCart, { n: it.quantity })) + '</span>' : '') +
        '</p>' +
        (extra > 0 ? '<p class="ibcs__more">' + esc(tpl(T.more, { n: extra })) + '</p>' : '') +
      '</div>';
    sheet.querySelector('#ibcs-title').textContent = items.length > 1 ? T.addedMany : T.added;
  }

  function renderTotals(cart) {
    sheet.querySelector('[data-ibcs-count]').textContent = T.subtotal + ' (' + itemsLabel(cart.item_count) + ')';
    sheet.querySelector('[data-ibcs-total]').innerHTML = priceHTML(cart.total_price, cart.currency);
    var go = sheet.querySelector('.ibcs__go');
    go.innerHTML = esc(T.viewCart) + ' <span class="ibcs__go-n">(' + cart.item_count + ')</span>';
    var ship = sheet.querySelector('[data-ibcs-ship]');
    var s = shippingInfo(cart);
    if (!s) { ship.hidden = true; return; }
    ship.hidden = false;
    ship.classList.toggle('is-done', s.left <= 0);
    ship.innerHTML =
      '<div class="ibcs__ship-row">' + truckSVG() + '<p>' + s.html + '</p></div>' +
      '<div class="ibcs__track" aria-hidden="true"><span style="width:' + s.pct.toFixed(1) + '%"></span></div>';
  }

  function openSheet(items, cart) {
    if (!items || !items.length) return;
    buildSheet();
    lastFocus = document.activeElement;
    renderAdded(items);
    renderTotals(cart);
    var recs = sheet.querySelector('[data-ibcs-recs]');
    loadRecs(items[0].product_id, sheet.querySelector('[data-ibcs-rail]'), recs);
    panel.querySelector('.ibcs__body').scrollTop = 0;
    sheet.hidden = false;
    document.documentElement.classList.add('ibcs-lock');
    // eslint-disable-next-line no-unused-expressions
    panel.offsetWidth;
    sheet.classList.add('is-open');
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 50);
  }

  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('ibcs-lock');
    setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.IBCart = { open: openSheet, close: closeSheet, refresh: function () { return getCart().then(function (c) { setCount(c.item_count); return c; }); } };

  /* ---------------- formularele „Adaugă în coș” ---------------- */
  function isAddForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var action = (form.getAttribute('action') || '').split('?')[0].split('#')[0];
    return /\/cart\/add\/?$/.test(action);
  }

  function setBusy(btn, on) {
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('btn--loading'); }
    else { btn.removeAttribute('aria-busy'); btn.classList.remove('btn--loading'); }
  }

  function showFormError(form, msg) {
    var old = form.querySelector('.errors.ib-form-error');
    if (old) old.remove();
    var div = document.createElement('div');
    div.className = 'errors text-center ib-form-error';
    div.setAttribute('role', 'alert');
    div.textContent = msg;
    form.appendChild(div);
  }

  function closeQuickShop(form) {
    var tip = form.closest('tool-tip');
    if (!tip) return;
    var x = tip.querySelector('[data-tool-tip-close]');
    if (x) x.click();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isAddForm(form) || form.hasAttribute('data-ib-native')) return;
    var fd;
    try { fd = new FormData(form); } catch (err) { return; }
    if (!fd.get('id')) return; // varianta epuizată: lăsăm tema să se ocupe
    if (fd.get('return_to')) return; // formular care duce intenționat altundeva (ex. direct la checkout)
    // Tema (header-cart-drawer) își actualizează coșul din secțiunea „cart-ajax” primită în răspuns.
    if (!fd.get('sections')) fd.append('sections', 'cart-ajax');
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = (e.submitter && e.submitter.tagName === 'BUTTON') ? e.submitter : form.querySelector('[name="add"], [type="submit"]');
    if (btn && btn.getAttribute('aria-busy') === 'true') return;
    setBusy(btn, true);
    var oldErr = form.querySelector('.errors');
    if (oldErr) oldErr.remove();

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          showFormError(form, (res.j && (res.j.description || res.j.message)) || T.error);
          return;
        }
        var items = res.j.items || [res.j];
        return getCart().then(function (cart) {
          setCount(cart.item_count);
          closeQuickShop(form);
          document.dispatchEvent(new CustomEvent(EV_ADDED, {
            bubbles: true,
            detail: { product: res.j, ibHandled: true, preventCartOpen: true }
          }));
          if (isCartPage) refreshSummary(cart);
          else openSheet(items, cart);
        });
      })
      .catch(function () {
        // Rezervă: trimitem formularul normal (duce în coș), ca adăugarea să nu se piardă.
        form.setAttribute('data-ib-native', '');
        HTMLFormElement.prototype.submit.call(form);
      })
      .then(function () { setBusy(btn, false); });
  }, true);

  // Adăugările rapide ale temei (din colecții) – deschidem același panou.
  document.addEventListener(EV_ADDED, function (e) {
    var d = e.detail || {};
    if (d.ibHandled) return;
    if (d.preventCartOpen) { getCart().then(function (c) { setCount(c.item_count); }); return; }
    var p = d.product || {};
    var items = p.items || (p.key ? [p] : []);
    getCart().then(function (cart) {
      setCount(cart.item_count);
      if (isCartPage) refreshSummary(cart);
      else if (items.length) openSheet(items, cart);
    });
  });

  /* ---------------- pagina de coș ---------------- */
  var sticky, mainCheckout;

  function refreshSummary(cart) {
    if (!isCartPage) return;
    var p = cart ? Promise.resolve(cart) : getCart();
    p.then(function (c) {
      if (!c || typeof c.item_count !== 'number') return;
      var hasForm = !!document.getElementById('CartPageForm');
      // Coșul s-a golit (sau s-a umplut din „Ți-ar putea plăcea” pe coșul gol):
      // reîncărcăm o singură dată ca pagina să arate starea corectă.
      if ((c.item_count === 0 && hasForm) || (c.item_count > 0 && !hasForm)) {
        var lastReload = parseInt(store('ib:reload'), 10) || 0;
        if (Date.now() - lastReload > 5000) {
          store('ib:reload', String(Date.now()));
          location.reload();
        }
        return;
      }
      if (c.item_count === 0) return;
      setCount(c.item_count);
      document.querySelectorAll('[data-ib-count-label]').forEach(function (el) { el.textContent = itemsLabel(c.item_count); });
      document.querySelectorAll('[data-ib-total]').forEach(function (el) { el.innerHTML = priceHTML(c.total_price, c.currency); });
      renderPoints(c);
    });
  }

  // Bloom Club: 100 puncte pentru fiecare 100 lei; 200 puncte = 10 lei reducere.
  function renderPoints(cart) {
    var el = document.querySelector('[data-ib-points]');
    if (!el) return;
    if (!C.pointsEnabled || !T.points || cart.currency !== 'RON') { el.hidden = true; return; }
    var lei = cart.total_price / 100;
    var points = Math.floor(lei / 100) * 100;
    if (points >= 100) {
      el.innerHTML = tpl(T.points, { points: points, value: esc(money(Math.round(points / 200 * 10) * 100, 'RON')) });
    } else {
      el.innerHTML = tpl(T.pointsLeft, { amount: '<strong>' + esc(money(10000 - cart.total_price, 'RON')) + '</strong>' });
    }
    el.hidden = false;
  }

  function initBackLinks() {
    var last = store('ib:last');
    document.querySelectorAll('[data-ib-back]').forEach(function (a) {
      if (last) a.setAttribute('href', last);
      a.addEventListener('click', function (ev) {
        try {
          var ref = document.referrer ? new URL(document.referrer) : null;
          if (ref && ref.origin === location.origin && !/\/cart/.test(ref.pathname) && history.length > 1) {
            ev.preventDefault();
            history.back();
          }
        } catch (err) {}
      });
    });
  }

  function initSticky() {
    sticky = document.querySelector('[data-ib-sticky]');
    mainCheckout = document.querySelector('#CartPageForm .cart__checkout');
    if (!sticky || !mainCheckout || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 768px)');
    var visible = true;
    function apply() {
      var show = mq.matches && !visible;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.documentElement.classList.toggle('ib-sticky-on', show);
    }
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      apply();
    }, { threshold: 0 }).observe(mainCheckout);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    sticky.hidden = false;
    apply();
  }

  function initCartPage() {
    initBackLinks();
    initSticky();
    var slot = document.querySelector('[data-ib-recs-slot]');
    if (slot) loadRecs(slot.getAttribute('data-product-id'), slot.querySelector('[data-ib-rail]'), slot);
    document.addEventListener(EV_UPDATED, function (e) { refreshSummary(e.detail && e.detail.cart); });
    refreshSummary();
  }

  if (isCartPage) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCartPage);
    else initCartPage();
  }
})();
